import { SUPER, ADMIN, USER } from "@/helpers/authorization";

const routes = {
  login: {
    path: "/Login",

    children: {
      loginForm: {
        path: "/",
        name: "Login",
        meta: {
          hideNavbar: true,
        },
      },
      forgotPassword: {
        path: "/Forgot",
        name: "ForgotPassword",
        meta: {
          hideNavbar: true,
        },
      },
      resetPassword: {
        path: "/ResetPassword",
        name: "ResetPassword",
        meta: {
          hideNavbar: true,
        },
      },
    },
  },
  monitoring: {
    path: "/Monitoring",
    name: "Monitoring",
    authorize: [SUPER, ADMIN, USER],
  },
  historical: {
    path: "/Historical",
    name: "Historical",
    authorize: [SUPER, ADMIN, USER],
  },
  lightningHistory: {
    path: "/LightningHistory",
    name: "LightningHistory",
    authorize: [SUPER, ADMIN, USER],
  },
  aboutView: {
    path: "/AboutView",
    name: "About",
    authorize: [SUPER, ADMIN],
  },
  responseError: {
    path: "/error",
    name: "ResponseError",
  },
  management: {
    path: "/management",
    name: "Management",
    authorize: [SUPER, ADMIN],
  },
  userConfig: {
    path: "/Configuration",
    name: "Configuration",
    authorize: [SUPER, ADMIN, USER],
  },
};

export default routes;
